// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { parseDuration } from '../../../../../../lib/utility';
import { Note as NoteType } from '../../../../../../types/Model';
import { S } from './styles';

interface NoteProps extends React.ComponentPropsWithRef<'div'> {
  note: NoteType;
  isEditing: boolean;
  setEditingNote: (noteId: string) => void;
  isDeleted: boolean;
  onSave: (message: string) => void;
  onDelete: () => void;
  onRestore: () => void;
}

const Note: React.FC<NoteProps> = (props): JSX.Element => {
  const {
    note: {
      id,
      vodId,
      time,
      message,
    },
    isEditing,
    isDeleted,
    setEditingNote,
    onSave,
    onDelete,
    onRestore,
    onClick,
    ...otherProps
  } = props;
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const saveButtonRef = useRef<HTMLImageElement>(null);
  const [tempMessage, setTempMessage] = useState<string>(message);

  // Resizing textarea when inputing
  useLayoutEffect(() => {
    if (textareaRef.current) {
      // resize on deleting
      textareaRef.current.style.height = 'inherit';
      // resize on typing
      textareaRef.current.style.height = `${Math.max(textareaRef.current.scrollHeight)}px`;
    }
  }, [tempMessage]);

  useLayoutEffect(() => {
    if (isEditing) {
      textareaRef.current?.focus();
    }
  }, [isEditing])

  useEffect(() => {
    setTempMessage(message);
  }, [message])

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTempMessage(e.target.value);
  }

  const handleEdit: React.MouseEventHandler = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setEditingNote(id);
  }

  const handleBlur = () => {
    onSave(tempMessage);
  }

  const handleDelete: React.MouseEventHandler = (e) => {
    e.stopPropagation();
    onDelete();
  }

  const preventClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    console.log({ isEditing, isDeleted })
    if (!isEditing && !isDeleted) {
      onClick && onClick(e);
    }
  }

  return (
    <S.Container isDeleted={isDeleted} isEdit={isEditing} {...otherProps} onClick={preventClick}>
      {
        isDeleted ? (
          <>
            <S.DeletedText><FormattedMessage id="F010" /></S.DeletedText>
            <S.RestoreButton onClick={onRestore}><FormattedMessage id="F011" /></S.RestoreButton>
          </>
        )
          :
          (
            <>
              <S.MessageText
                ref={textareaRef}
                disabled={!isEditing}
                value={tempMessage}
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyDown={e => e.stopPropagation()}/> {/* Prevent Shortcuts Triggering */}
              <S.ToolBoxContainer>
                <S.DurationText>{parseDuration(time).auto}</S.DurationText>
                <S.ToolsContainer isEdit={isEditing}>
                  {
                    isEditing ? <S.SaveButton /> : (
                      <>
                        <S.DeleteButton onClick={handleDelete} />
                        <S.EditButton onClick={handleEdit} />
                      </>
                    )
                  }
                </S.ToolsContainer>
              </S.ToolBoxContainer>
            </>
          )
      }
    </S.Container>
  );
}

export { Note as default };
